import classNames from "classnames";
import React from "react";
import { Container } from "react-bootstrap";
import { useBootstrapPrefix } from "react-bootstrap/esm/ThemeProvider";
import type { BsPrefixProps, BsPrefixRefForwardingComponent } from "react-bootstrap/esm/helpers";
import { EventImpression } from "./EventImpression";

export interface LandingHeaderProps extends BsPrefixProps, React.HTMLAttributes<HTMLElement> {
	theme?: "retail" | "corporate";
	sendEvent?: boolean;
}

export const LandingHeader: BsPrefixRefForwardingComponent<"div", LandingHeaderProps> = React.forwardRef<
	HTMLElement,
	LandingHeaderProps
>(({ as: Component = "div", bsPrefix, id, className, sendEvent, theme = "retail", children, ...props }, ref) => {
	bsPrefix = useBootstrapPrefix(bsPrefix, "ui3-landing-header");

	return (
		<EventImpression id={id} sendEvent={sendEvent}>
			<Component id={id} ref={ref} className={classNames(className, `theme-${theme}`, bsPrefix)} {...props}>
				<Container>{children}</Container>
			</Component>
		</EventImpression>
	);
});
